import { render, staticRenderFns } from "./InformativeLayout.vue?vue&type=template&id=7a8b02dc&scoped=true&"
import script from "./InformativeLayout.vue?vue&type=script&lang=ts&"
export * from "./InformativeLayout.vue?vue&type=script&lang=ts&"
import style0 from "./InformativeLayout.vue?vue&type=style&index=0&id=7a8b02dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8b02dc",
  null
  
)

export default component.exports